import React, { useEffect, useRef, forwardRef, useImperativeHandle } from "react";

const basePath = process.env.MIX_REACT_BASEPATH || "";

const DropzoneUpload = forwardRef((props, ref) => {
    const dropzoneRef = useRef(null);
    const dz = useRef(null);

    useImperativeHandle(ref, () => ({
        getFiles: () => (dz.current ? dz.current.getAcceptedFiles() : []),
        removeAll: () => dz.current?.removeAllFiles(true),
    }));

    useEffect(() => {
        const script = document.createElement("script");
        script.src = `${basePath}/assets/js/dropzone-min.js`;
        script.onload = () => {
            if (window.Dropzone) {
                window.Dropzone.autoDiscover = false;
                dz.current = new window.Dropzone(dropzoneRef.current, {
                    url: "#", // not used
                    acceptedFiles: ".pdf,.jpg,.jpeg,.png",
                    autoProcessQueue: false,
                    maxFiles: 10,
                    addRemoveLinks: true,
                    dictDefaultMessage: "Drop or click to upload (PDF)",
                });
            }
        };
        document.body.appendChild(script);
        return () => dz.current?.destroy();
    }, []);

    return (
        <div className="dropzone dz-clickable" ref={dropzoneRef}>
            <div className="dz-default dz-message">
                <button className="dz-button" type="button">
                    <i className="fi fi-rr-cloud-upload-alt"></i>
                    Drag & Drop or <span>Browse</span>
                    <span className="small_text">
                        Please upload document in PDF, JPG, PNG format
                    </span>
                </button>
            </div>
        </div>
    );
});

export default DropzoneUpload;

